import type { FC } from 'react'

import { useLocalDate } from '@/hooks/use-local-date'

export const LocalDate: FC<{ date: string }> = ({ date }) => {
  const { formatDate } = useLocalDate()

  return (
    <span>
      {formatDate({
        date,
      })}
    </span>
  )
}
